import { Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
import React, { FunctionComponent, memo } from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(2),
  },
}));

const ChangesDelayedWarning: FunctionComponent = memo(() => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Typography color="textSecondary">
        Any changes you submit will be applied to the device when it performs
        its next sync.
      </Typography>
    </div>
  );
});

export default ChangesDelayedWarning;
